import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { FinancialFlowTypeEnum } from '@zaoblako/shared/modules/catalog/enums/financial-flow-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link FinancialFlowTypeEnum} enumeration values */
export const FinancialFlowTypeEnumI18n: EnumI18nInterface<FinancialFlowTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [FinancialFlowTypeEnum.INCOME]: 'Доходы',
    [FinancialFlowTypeEnum.EXPENSE]: 'Расходы',
  },
  [I18nLocalesEnum.EN_US]: {
    [FinancialFlowTypeEnum.INCOME]: 'Доходы',
    [FinancialFlowTypeEnum.EXPENSE]: 'Расходы',
  },
};
